var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isHidden && _vm.items.length)?_c('gl-disclosure-dropdown',{staticClass:"!gl-pr-0",attrs:{"icon":"list-bulleted","items":_vm.items}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }